import { render, staticRenderFns } from "./ModalOrder.vue?vue&type=template&id=5fa5cade"
import script from "./ModalOrder.vue?vue&type=script&lang=js"
export * from "./ModalOrder.vue?vue&type=script&lang=js"
import style0 from "./ModalOrder.vue?vue&type=style&index=0&id=5fa5cade&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports